import h from 'hyperscript';

import './sidebar.css';

const COMPONENT_NAME = 'd-sidebar';

class Sidebar extends HTMLElement {
  readonly #backdrop = h(`.${COMPONENT_NAME}--backdrop`);

  connectedCallback() {
    this.setAttribute('role', 'complementary');
    this.classList.add(COMPONENT_NAME);
    this.#updateVisibility();
    this.parentElement!.insertBefore(this.#backdrop, this.nextSibling);
  }

  #updateVisibility(value = this.open) {
    this.style.display = value ? '' : 'none';
  }

  disconnectedCallback() {
    this.#backdrop.remove();
  }

  set open(value: boolean) {
    if (value !== this.open) {
      if (value || !(this.classList.contains('is-overlay') || this.classList.contains('is-animated'))) {
        this.#updateVisibility(value);
      }
      this.setAttribute('aria-hidden', String(!value));
      this.dispatchEvent(new CustomEvent('change:open', { detail: this.open }));
    }
  }

  /**
   * @return Whether the sidebar is open or not
   */
  get open() {
    return this.getAttribute('aria-hidden') !== 'true';
  }
}

customElements.define(COMPONENT_NAME, Sidebar);
